import { DateTime } from 'luxon'

/**
 * Converts a JS Date range to UTC ISO strings by interpreting the wall-clock values
 * in the given timezone (keepLocalTime: true), so "Mar 1 00:00" means Mar 1 00:00 in that TZ.
 */
export function rangeToISOInTimezone(range: [Date, Date], tz: string): { startISO: string; endISO: string } {
  const [startDate, endDate] = range
  return {
    startISO: DateTime.fromJSDate(startDate).setZone(tz, { keepLocalTime: true }).toISO() || '',
    endISO: DateTime.fromJSDate(endDate).setZone(tz, { keepLocalTime: true }).toISO() || '',
  }
}
